import { faShieldAlt, faBolt, faChartLine, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, forwardRef } from "react";
import { appContext } from "../../App";

export const About = forwardRef<HTMLDivElement>((props, ref) => {
    const { darkMode } = useContext(appContext);

    const advantages = [
        { 
            icon: faShieldAlt, 
            title: "Secure & Regulated", 
            description: "Fully compliant UAE operations" 
        },
        { 
            icon: faBolt, 
            title: "Maximize Profit", 
            description: "1% commission, highest returns" 
        },
        { 
            icon: faChartLine, 
            title: "Smart Mining", 
            description: "AI-powered coin switching" 
        },
        { 
            icon: faGlobe, 
            title: "Global Infrastructure", 
            description: "1EH+ network power" 
        },
    ];

    return (
        <section ref={ref} className="py-20 relative min-h-screen flex items-center justify-center">
            <div className="container mx-auto px-4">
                <div className="flex flex-col lg:flex-row items-start gap-12">
                    {/* Left Column - Value Proposition */}
                    <div className="w-full lg:w-1/2">
                        
                        <h2 className="text-4xl md:text-5xl font-bold mb-6 text-slate-900 dark:text-white">
                            Your Gateway to <br />
                            <span className="text-blue-500">Profitable</span> Crypto
                        </h2>
                        
                        <div className="mb-8">
                            <p className="text-lg text-slate-700 dark:text-slate-300 mb-4 font-medium">
                                We simplify crypto mining. Since 2017, we've helped investors worldwide 
                                generate consistent passive income with enterprise-grade infrastructure.
                            </p>
                            <p className="text-slate-600 dark:text-slate-400">
                                Operating from the UAE's most secure facilities, we eliminate the technical 
                                complexity while maximizing your returns. Just invest, and watch your 
                                portfolio grow.
                            </p>
                        </div>
                    </div>

                    {/* Right Column - Advantages Grid */}
                    <div className="w-full lg:w-1/2">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {advantages.map((advantage, index) => (
                                <div
                                    key={index}
                                    className="p-6 rounded-2xl bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 hover:border-blue-400 transition-all duration-300 hover:shadow-xl"
                                >
                                    <div className="flex items-start gap-4">
                                        <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center flex-shrink-0">
                                            <FontAwesomeIcon 
                                                icon={advantage.icon} 
                                                className="text-blue-500 text-lg" 
                                            />
                                        </div>
                                        <div>
                                            <h3 className="font-bold text-slate-800 dark:text-white mb-2">
                                                {advantage.title}
                                            </h3>
                                            <p className="text-sm text-slate-600 dark:text-slate-400">
                                                {advantage.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        
                        {/* Social Proof */}
                        {/* <div className="mt-10 p-6 rounded-2xl bg-gradient-to-r from-blue-500/5 to-blue-600/5 border border-blue-500/20">
                            <p className="text-slate-700 dark:text-slate-300 italic">
                                "Our clients average 25% annual returns with zero technical overhead. 
                                Let us handle the mining while you focus on growing your wealth."
                            </p>
                            <div className="mt-4 flex items-center">
                                <div className="w-8 h-8 rounded-full bg-blue-500 mr-3"></div>
                                <div>
                                    <p className="font-bold text-slate-800 dark:text-white">CEO & Founder</p>
                                    <p className="text-sm text-slate-600 dark:text-slate-400">7+ Years in Crypto Mining</p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
});